import GentleUtil from '../common/util';
import GentleLang from './lang';
import language from '../lang'
import GentleServiceCustomHandler from '../service/customServiceHandler';
import GentleAppState from '../common/appstate';
import GentleComponentBubble from '../component/bubble';
import { translate } from '../main/main';

const TYPE = GentleLang.type;

const sendText = function(html){ 
    
    GentleUtil.quickMenuHide();
    GentleComponentBubble.insertUserBubble({html})
}
// 주문상태 / 1(주문완료), 2(결제완료), 11(주문취소), 12(결제취소), 13(미결제마감), 101(배송준비중), 102(배송중), 13(배송완료)

export default {
    OrderStatusType: {
        OrderComplete: 1, // 주문완료
        Paid: 2, // 결제완료
        OrderCancel: 11, // 주문취소
        PayCancel: 12, // 결제취소, 
        UnPaid: 13, // 미결제마감
        Ready: 101, // 배송준비중
        Moving: 102, // 배송중
        Completed: 103, // 배송완료
    },
    Storage:{
        service: 'service', // 로그인 직후 접근해야 할 서비스
        fontSize: 'fontSize',
    },
    ATOMY_HOME : {
        kr:{
            dev: '8a02048a7839be78017842acb5800002',
            prd: '8a02048a7839be78017842acb5800002'
        },

        en:{
            dev: '8a0c528a78631f120179110554ce0001',
            prd: '8a0c528a78631f120179110554ce0001'
        }
    },
    // 애터미 개발/운영 도메인 
    ATOMY_URL : {
        dev:{
            pcDomain: 'www.atomy.kr',
            mobileDomain: 'mtest.atomy.com'
        },

        prd:{
            pcDomain: 'www.atomy.kr',
            mobileDomain: 'm.atomy.com'
        }
    },

    // SSO 개발/운영 도메인  
    SSO_URL:{
        pcDomain: 'https://{atomyDomain}/v2/home/account/SignInSso?t={Token}&u={Url}',
        mobileDomain: 'https://{atomyDomain}/kr/m/signin/sso?t={Token}&u={Url}' 
    },

    FreeDeliv: 30000, // 무료배송 기준.. 이거 이상이면 무료
    Deliv: 2500, // 배송비
    GRADE : 5,  // 사업자 분류 기준... 5이상이면 사업자이다.

    // 퀵메뉴
    QUICK_MENU_ARRAY : {
        font:[
            {id:'font-handler-large', class:'font-handler', title:TYPE.Large, onClickEvent:()=> GentleAppState.setAppFont('large')},
            {id:'font-handler-middle', class:'font-handler', title:TYPE.Medium, onClickEvent:()=> GentleAppState.setAppFont('middle')},
            {id:'font-handler-small', class:'font-handler', title:TYPE.Small, onClickEvent:()=> GentleAppState.setAppFont('small')}
        ],
        papa:[
            {title:TYPE.GoHome, icon:'<i class="at-icon at-home at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.GoHome))},
            {title:TYPE.Notice, icon:'<i class="at-icon at-speaker at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.Notice))},
            {title:TYPE.Faq, icon:'<i class="at-icon at-faq at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.Faq))},
            {title:TYPE.SearchProduct, icon:'<i class="at-icon at-search at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translateService(language.search, language.search.type.Search))},
            {title:TYPE.Orders, icon:'<i class="at-icon at-order-details at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.Orders))},
            {title:TYPE.Invite, icon:'<i class="at-icon at-joinus at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.Invite))},
        ],
        tomy:[
            {title:TYPE.GoHome, icon:'<i class="at-icon at-home at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.GoHome))},
            {title:TYPE.Notice, icon:'<i class="at-icon at-speaker at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.Notice))},
            {title:TYPE.SearchProduct, icon:'<i class="at-icon at-search at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translateService(language.search, language.search.type.Search))},
            {title:TYPE.CheckApprove, icon:'<i class="at-icon at-approve at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.CheckApprove))},
            {title:TYPE.CheckIncome, icon:'<i class="at-icon at-sales at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.CheckIncome))},
            {title:TYPE.Invite, icon:'<i class="at-icon at-joinus at-3x"></i>', onClickEvent:()=>sendText(GentleLang.translate(GentleLang.type.Invite))},
        ]
    },
    
    // 전체 서비스 목록
    SERVICE_ARRAY : [
        {title:'인트로-연동', speech:'인트로', speech_EN: 'Intro'},
        {title:'처음으로-연동', speech:'처음으로', speech_EN: 'to the first step'},
        {title:'로그인-연동', speech:'로그인', speech_EN: 'Login'},
        {title:'로그아웃-연동', speech:'로그아웃', speech_EN: 'Logout'},
        {title:'프로필등록-연동', speech:'프로필등록', speech_EN: 'Profile registration'},
        {title:'프로필수정-연동', speech:'프로필수정', speech_EN: 'Edit Profile'},
        {title:'회원초대-연동', speech:'회원초대', speech_EN: 'Member invitation'},
        {title:'매출조회-연동', speech:'매출조회', speech_EN: 'Sales Inquiry'},
        {title:'수당조회-연동', speech:'수당조회', speech_EN: 'Commission inquiry'},
        {title:'상품검색-연동', speech:'상품검색', speech_EN: 'Product search'},
        {title:'인기상품-연동', speech:'인기상품', speech_EN: 'Search for popular products'},
        {title:'장바구니-연동', speech:'장바구니', speech_EN: 'Shopping cart'},
        {title:'주문내역조회-연동', speech:'주문내역조회', speech_EN: 'Order history'},
        {title:'공지사항-연동', speech:'공지사항', speech_EN: 'Notice inquiry'},
        {title:'일정조회-연동', speech:'일정조회', speech_EN: 'schedule inquiry'},
        {title:'고객센터 연결-연동', speech:'고객센터 연결', speech_EN: 'Kakao talk consultation connection'},
        {title:'회원가입안내-연동', speech:'회원가입안내', speech_EN: 'Sign Up'},
        {title:'승인잔액조회-연동', speech:'승인잔액 조회', speech_EN: 'Inquiry of Approval Balance'},
        {title:'신상품조회-연동', speech:'신상품조회', speech_EN: 'Inquiry of new products'},
        {title:'마켓팅플랜-연동', speech:'마켓팅플랜', speech_EN: 'Marketing plan description'},
        {title:'소실적조회-연동', speech:'소실적 추천상품', speech_EN: 'Recommend products tailored to your needs'},
        {title:'센터정보찾기-연동', speech:'센터 정보 찾기', speech_EN: ''},
    ]

};
